import { useDataSaver } from "@/context/DataSaverContext";

export default function Particles({ count = 24 }) {
  const { dataSaver } = useDataSaver();
  if (dataSaver) return null;
  return (
    <div className="particles no-saver absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {Array.from({ length: count }).map((_, i) => (
        <span
          key={i}
          style={{
            left: `${(i * 4.1) % 100}%`,
            width: `${2 + (i % 4)}px`,
            height: `${2 + (i % 4)}px`,
            animationDuration: `${8 + (i % 7) * 2}s`,
            animationDelay: `${(i % 10) * 0.8}s`,
          }}
        />
      ))}
    </div>
  );
}
